import { render, staticRenderFns } from "./TenantTransactionsCard.vue?vue&type=template&id=4ad7f306&scoped=true"
import script from "./TenantTransactionsCard.vue?vue&type=script&lang=js"
export * from "./TenantTransactionsCard.vue?vue&type=script&lang=js"
import style0 from "./TenantTransactionsCard.vue?vue&type=style&index=0&id=4ad7f306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad7f306",
  null
  
)

export default component.exports